import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type LoadFreightRefusalFieldsFragment = { __typename?: 'LoadFreightRefusal', code: string, loadId: string, lineIds: Array<string>, message: string };

export type LoadFreightOrderFieldsFragment = { __typename?: 'LoadFreightOrderResult', orderId: string, orderNumber: string, outcome: Types.LoadFreightOutcome, skipReason?: Types.LoadFreightSkipReason | null, warnings: Array<Types.LoadFreightWarning>, message: string, containers: number, share: number, minimum?: number | null, minimumApplied: boolean, freight: number, surcharge: number, currentFreight: number, currentSurcharge: number, unplannedContainers: number, unpricedLoadNumber?: number | null, contributions: Array<{ __typename?: 'LoadFreightContributionResult', loadId: string, loadNumber: number, carrierId: string, rateBasis: Types.CarrierRateBasis, rateAmount: number, miles?: number | null, stops: number, loadContainers: number, loadCost: number, containers: number, share: number, surchargePercent: number, portion: number, surcharge: number }> };

export type PreviewLoadFreightQueryVariables = Types.Exact<{
  loadId: Types.Scalars['ID']['input'];
}>;


export type PreviewLoadFreightQuery = { __typename?: 'Query', previewLoadFreight: { __typename?: 'LoadFreightPreview', inputRevision: string, refusal?: { __typename?: 'LoadFreightRefusal', code: string, loadId: string, lineIds: Array<string>, message: string } | null, results: Array<{ __typename?: 'LoadFreightOrderResult', orderId: string, orderNumber: string, outcome: Types.LoadFreightOutcome, skipReason?: Types.LoadFreightSkipReason | null, warnings: Array<Types.LoadFreightWarning>, message: string, containers: number, share: number, minimum?: number | null, minimumApplied: boolean, freight: number, surcharge: number, currentFreight: number, currentSurcharge: number, unplannedContainers: number, unpricedLoadNumber?: number | null, contributions: Array<{ __typename?: 'LoadFreightContributionResult', loadId: string, loadNumber: number, carrierId: string, rateBasis: Types.CarrierRateBasis, rateAmount: number, miles?: number | null, stops: number, loadContainers: number, loadCost: number, containers: number, share: number, surchargePercent: number, portion: number, surcharge: number }> }> } };

export type GetFreightLoadNumbersQueryVariables = Types.Exact<{
  where: Types.LoadDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetFreightLoadNumbersQuery = { __typename?: 'Query', logisticsLoads?: { __typename?: 'LogisticsLoadsConnection', totalCount: number, nodes?: Array<{ __typename?: 'LoadDocument', loadId: string, loadNumber: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const LoadFreightRefusalFieldsFragmentDoc = new TypedDocumentString(`
    fragment LoadFreightRefusalFields on LoadFreightRefusal {
  code
  loadId
  lineIds
  message
}
    `, {"fragmentName":"LoadFreightRefusalFields"});
export const LoadFreightOrderFieldsFragmentDoc = new TypedDocumentString(`
    fragment LoadFreightOrderFields on LoadFreightOrderResult {
  orderId
  orderNumber
  outcome
  skipReason
  warnings
  message
  containers
  share
  minimum
  minimumApplied
  freight
  surcharge
  currentFreight
  currentSurcharge
  unplannedContainers
  unpricedLoadNumber
  contributions {
    loadId
    loadNumber
    carrierId
    rateBasis
    rateAmount
    miles
    stops
    loadContainers
    loadCost
    containers
    share
    surchargePercent
    portion
    surcharge
  }
}
    `, {"fragmentName":"LoadFreightOrderFields"});
export const PreviewLoadFreightDocument = new TypedDocumentString(`
    query PreviewLoadFreight($loadId: ID!) {
  previewLoadFreight(loadId: $loadId) {
    inputRevision
    refusal {
      ...LoadFreightRefusalFields
    }
    results {
      ...LoadFreightOrderFields
    }
  }
}
    fragment LoadFreightRefusalFields on LoadFreightRefusal {
  code
  loadId
  lineIds
  message
}
fragment LoadFreightOrderFields on LoadFreightOrderResult {
  orderId
  orderNumber
  outcome
  skipReason
  warnings
  message
  containers
  share
  minimum
  minimumApplied
  freight
  surcharge
  currentFreight
  currentSurcharge
  unplannedContainers
  unpricedLoadNumber
  contributions {
    loadId
    loadNumber
    carrierId
    rateBasis
    rateAmount
    miles
    stops
    loadContainers
    loadCost
    containers
    share
    surchargePercent
    portion
    surcharge
  }
}`);
export const GetFreightLoadNumbersDocument = new TypedDocumentString(`
    query GetFreightLoadNumbers($where: LoadDocumentFilterInput!, $first: Int!) {
  logisticsLoads(first: $first, where: $where) {
    nodes {
      loadId
      loadNumber
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    PreviewLoadFreight: build.query<PreviewLoadFreightQuery, PreviewLoadFreightQueryVariables>({
      query: (variables) => ({ document: PreviewLoadFreightDocument, variables })
    }),
    GetFreightLoadNumbers: build.query<GetFreightLoadNumbersQuery, GetFreightLoadNumbersQueryVariables>({
      query: (variables) => ({ document: GetFreightLoadNumbersDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { usePreviewLoadFreightQuery, useLazyPreviewLoadFreightQuery, useGetFreightLoadNumbersQuery, useLazyGetFreightLoadNumbersQuery } = injectedRtkApi;
